import {
    DEALERADDUPDATEDISTRICTLIST_SUCCESS,
    DEALERADDUPDATEDISTRICTLIST_FAILED,
    RESET_DEALERADDUPDATEDISTRICTLIST,
    LOADING_DEALERADDUPDATEDISTRICTLIST,
    NETWORK_ERROR_DEALERADDUPDATEDISTRICTLIST
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_DEALERADDUPDATEDISTRICTLIST:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case DEALERADDUPDATEDISTRICTLIST_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case DEALERADDUPDATEDISTRICTLIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_DEALERADDUPDATEDISTRICTLIST:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_DEALERADDUPDATEDISTRICTLIST:
            return (state = initialState);
        default:
            return state;
    }
};